/**
 * Collection hero — scroll parallax (media + subtle copy drift)
 */
(function () {
  function initParallax(hero) {
    if (!hero || hero.dataset.parallaxBound === 'true') return;
    hero.dataset.parallaxBound = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var media = hero.querySelector('.coll-hero__media');
    var copy = hero.querySelector('.coll-hero__copy');
    if (!media) return;

    var ticking = false;

    function update() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      var height = rect.height || 1;

      // Only animate while hero is in or near viewport
      if (rect.bottom < -40 || rect.top > window.innerHeight + 40) return;

      // 0 at hero top aligned to viewport top; grows as user scrolls down
      var scrolled = Math.max(0, -rect.top);
      var progress = Math.min(1, scrolled / height);
      var mediaY = scrolled * 0.42;
      var copyY = scrolled * 0.18;
      var copyOpacity = Math.max(0.28, 1 - progress * 0.72);

      media.style.transform = 'translate3d(0, ' + mediaY.toFixed(2) + 'px, 0)';
      if (copy) {
        copy.style.transform = 'translate3d(0, ' + copyY.toFixed(2) + 'px, 0)';
        copy.style.opacity = copyOpacity.toFixed(3);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.coll-hero[data-parallax="true"]').forEach(initParallax);
  });
})();
